export default "__VITE_ASSET__CHGhpOiG__"